import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGraphUniqueBought } from "./uniqueBoughtAPI";

const initialState = {
    status: "idle",
    error: null,
    data: {},
    boughtVisitors: [],
    boughtPercentVisitors: [],
    weeks: [],
};

export const graphUniqueBought = createAsyncThunk(
  "uniqueBought/bought",
  async (user, { rejectWithValue }) => {
    try {
        const dbpath = `${user}/graph-uniqueSalesDone`
        const response = await fetchGraphUniqueBought(dbpath, user, 'graph-uniqueSalesDone');
        return response.data;
    } catch (error) {
        return rejectWithValue(error);
    }
  }
);

const uniqueBoughtSlice = createSlice({
  name: "uniqueBought",
  initialState,
  reducers: {
    resetuniqueBoughtSlice: (state, action) => {
      return { ...initialState };
    },
      setUniqueBought: (state, action) => {
          let data = action.payload;
          let salesVisitors = []
          console.log("data:",data) ;

          if (data[0] && data[0].length > 2) {
            salesVisitors = data[0][1].data.map((item, i) => {
              const visitors = data[0][0].data[i] ?? 0;
              const percent = data[0][2].data[i] ?? 0;
              return Math.round(visitors * percent / 100);
            });
          }
    
          state.boughtVisitors = salesVisitors;
          state.boughtPercentVisitors = (data[0] && data[0][2] && data[0][2]['data']) ? data[0][2]['data'].map(item => item ?? 0) : [];
          state.weeks = data[1] ? data[1].map(item => item ?? '') : [];
        }
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphUniqueBought.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphUniqueBought.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        try {
          state.data = result;
          // Other Data Capturing Code
        } catch (error) {
          // console.warn("uniqueBookings data not found!", error)
        }
      })
      .addCase(graphUniqueBought.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const { setUniqueBought,resetuniqueBoughtSlice } = uniqueBoughtSlice.actions;

    
export const SelectBoughtVisitors = (state) => state.uniqueBought.boughtVisitors;
export const SelectBoughtPercentVisitors = (state) => state.uniqueBought.boughtPercentVisitors;
export const SelectWeeks = (state) => state.uniqueBought.weeks;
export const SelectUniqueBoughtStatus = (state) => state.uniqueBought.status;

export default uniqueBoughtSlice.reducer;